import React, { Component, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import Select from "react-select";

const ProjectCounts = (props) => {
    const [haveProjectData, setHaveProjectData] = React.useState(false);
    const data = {
        labels: props?.data?.map(item => item._id?.toUpperCase()) || ["Showcase", "Rest"],
        datasets: [
            {
                data: props?.data?.map(item => item.count) || [0, 0],
                borderWidth: 3,
                borderColor: "rgba(255,255,255,1)",
                backgroundColor: [
                    "rgba(251, 62, 122, 1)",
                    "rgba(14, 138, 116, 1)",
                    "rgba(255, 123, 49, 1)"
                ],
                hoverBackgroundColor: [
                    "rgba(251, 62, 122, 0.5)",
                    "rgba(14, 138, 116, 0.5)",
                    "rgba(255, 123, 49, 0.5)"
                ]
            }
        ]
    };

    const options = {
        weight: 1,
        cutout: "60%",
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function (context) {
                        const label = context.label?.toUpperCase() || "";
                        const value = context.raw;
                        return value;
                    }
                }
            },
            legend: {
                display: true,
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    padding: 20,
                    font: {
                        size: 12,
                        family: "Poppins"
                    }
                }
            }
        }
    };

    useEffect(() => {
        let tmpHaveProjectData = false;

        if (props?.data?.length > 0) {
            for (let i = 0; i < props?.data?.length; i++) {
                if (props.data[i].count > 0) {
                    tmpHaveProjectData = true;
                    break;
                }
            }
        }
        setHaveProjectData(tmpHaveProjectData);
    }, [props.data]);

    const years = [];
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 2000; y--) {
        years.push({ label: y, value: y });
    }

    return (
        <div className="card event-bx">
            <div className="card-header border-0 mb-0">
                <h4 className="card-title mb-1 font-w500">Projects</h4>
                <Select
                    value={{
                        label: props.filters.year,
                        value: props.filters.year,
                    }}
                    onChange={(e) => {
                        props.handleYearChange(e.value);
                    }}
                    options={years}
                    name={`project - year`}
                    style={{
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                    }}
                    classNames={{
                        control: (state) => "form-control p-0 select-custom-css", // add your class here
                    }}
                />
            </div>
            <div className="card-body dz-scroll">
                {haveProjectData ? (
                    <Doughnut data={data} height={100} options={options} />
                ) : (
                    <div className="text-center h-100 d-flex justify-content-center align-items-center"><h4>No Project Data</h4></div>
                )}
            </div>
        </div>
    );

}

export default ProjectCounts;